<div class="d-flex flex-column justify-content-between">
  <ng-container *ngIf="!state.error && !state.verifyingOpay">
    <form autocomplete="off" (ngSubmit)="onSubmitBtnClicked()">
      <div
        class="zp:bg-ZTN-50 zp:border zp:border-ZTN-200 zp:rounded-lg zp:p-1 zp:mt-10 zp:text-ZTN-500 zp:font-medium zp:text-sm"
      >
        <div
          class="zp:text-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-white"
        >
          <div
            class="zp:p-5 zp:flex zp:justify-center zp:items-center zp:flex-col"
          >
            <div class="zp:mb-4">
              <svg-icon
                name="opay_channel"
                svgClass="img-fluid w-50"
              ></svg-icon>
            </div>
            <p class="zp:pb-2 zp:font-bold zp:text-base zp:text-ZTN-900">
              Pay with Opay
            </p>
            <p class="zp:text-sm zp:font-medium zp:text-ZTN-500">
              You will be redirected to the OPay checkout platform to complete
              your payment.
            </p>
          </div>
        </div>
      </div>
      <div class="zp:mt-6 zp:text-center">
        <button
          class="zp:bg-ZTG-BC zp:text-center zp:text-white zp:w-full zp:rounded-lg zp:font-bold zp:text-sm zp:py-3 zp:cursor-pointer"
          type="submit"
          [ngClass]="{
            'omni-btn-loading': loading,
          }"
        >
          <span>Proceed to Opay </span>
        </button>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="state.verifyingOpay">
    <div class="verification-loader">
      <span class="omni-spinner-text"
        >Please wait while we verify transaction</span
      >
      <div class="omni-spinner-border" role="status"></div>
    </div>
  </ng-container>
  <ng-container>
    <iframe
      frameborder="0"
      id="payWithOpayTarget"
      style="display: none"
    ></iframe>
  </ng-container>
  <ng-container *ngIf="state.error">
    <div
      class="zp:font-mont zp:flex zp:justify-center zp:items-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-ZTN-50 zp:p-1"
    >
      <div
        class="zp:text-center zp:bg-white zp:rounded-lg zp:py-4 zp:px-2 zp:basis-full"
      >
        <div class="zp:flex zp:justify-center zp:items-center zp:mb-3">
          <svg-icon name="warning" svgClass="img-fluid w-50"></svg-icon>
        </div>
        <div class="px-3">
          <div
            class="zp:font-semibold zp:text-lg zp:text-ZTN-900 zp:leading-5 zp:pb-2"
          >
            We could not process this transaction
          </div>
          <div class="zp:text-sm zp:text-ZTN-500 zp:font-normal zp:leading-5">
            <small class="zp:text-sm">
              {{ errorMessage }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
